module.exports = require("babel-runtime/core-js/object/get-prototype-of");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/object/get-prototype-of"
// module id = 33
// module chunks = 0